module.exports = __webpack_public_path__ + "static/media/logo_anim.de478a9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_anim.svg
// module id = 404
// module chunks = 0